import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import { Cota } from "../interfaces/Cota";

export const atualizarCotaService = async (
  cotaId: number | null | undefined,
  data: Partial<Cota>
) => {
  const Token = validateToken();

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/cota/${cotaId}`;

    try {
      const response = await axios.put(URL, data, {
        headers: { Authorization: Token.AuthStr },
      });

      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
